import React, { createContext } from 'react';

export const ConfigContext = createContext(null);

const withConfigAsContext = (Component, config) => {
   const InnerWithConfigAsContext = (props) => {
      return (
         <ConfigContext.Provider value={config}>
            <Component
               {...props}
            />
         </ConfigContext.Provider>
      );
   };

   return InnerWithConfigAsContext;
};


export default withConfigAsContext;
